import { css } from '@emotion/react';

export const bootstrap = css`
  $theme-colors: (
      "info": tomato,
      "danger": teal
  );

  @import "~bootstrap/scss/bootstrap";
`


// WEBPACK FOOTER //
// ./src/styles/bootstrap.ts